// CFD legend — FE-037 / spec §7.0.11.

import { CFD_STATUS_META, CFD_STATUS_ORDER } from "./statusMeta";


export function CfdLegend() {
  return (
    <ul
      data-testid="cfd-legend"
      role="list"
      className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-text-secondary"
    >
      {CFD_STATUS_ORDER.map((status) => {
        const meta = CFD_STATUS_META[status];
        return (
          <li
            key={status}
            data-testid={`cfd-legend-${status}`}
            className="inline-flex items-center gap-1.5"
          >
            <span
              aria-hidden="true"
              className={`inline-block h-2 w-2 rounded-sm ${meta.swatch}`}
            />
            <span>{meta.label}</span>
          </li>
        );
      })}
    </ul>
  );
}
